import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import imagen1 from '../img/get_view1.jpg'; 
import { GrupoContext } from '../GrupoContext';
import liderImage from '../img/lider_image.jpg';
import staffImage from '../img/staff_image.jpg';

const Rol3 = () => {  // Cambio en el nombre de la función a "Rol"
  const navigate = useNavigate();
  const { grupo } = useContext(GrupoContext);

  return (
    <div className="app" style={{ padding: '0', margin: '0', boxSizing: 'border-box' }}>
      <div className="main-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <div className="main-panel" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
          <div className="welcome-message" style={{ textAlign: 'center', marginBottom: '20px', width: '100%' }}>
            <h2>Bienvenido(a), selecciona tu rol</h2>
            <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
          </div>
          <div className="cards-container" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '50px', flexWrap: 'wrap', width: '95%' }}>
            <div className="card" style={{ backgroundColor: '#ffffff', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', width: 'calc(50% - 10px)', padding: '10px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={liderImage} alt="Solicitante" style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '10px' }} />
              <button onClick={() => navigate('/MenuSeniorGET')} style={{ padding: '10px 15px', backgroundColor: '#6500b3', color: 'white', border: '1px solid #a986d9', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', margin: '0 auto' }}>Senior GET</button>
            </div>
            <div className="card" style={{ backgroundColor: '#ffffff', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', width: 'calc(50% - 10px)', padding: '17px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={staffImage} alt="Senior GET" style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '10px' }} />
              <button onClick={() => navigate('/menustaff')} style={{ padding: '10px 15px', backgroundColor: '#6500b3', color: 'white', border: '1px solid #a986d9', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', margin: '0 auto' }}>Staff</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rol3; // Asegúrate de exportar con el nombre correcto
